import React from 'react'
import axios from 'axios'

import QuantitiesActions from '~/actions/quantities.js'

import DeleteWithConfirm from '~/modules/_core/deleteWithConfirm.jsx'

import apiUtils from '~/helper/api.js'


export default class RecipeQuantitiesModalAddEdit extends React.Component {
	handleConfirm = () => {
		axios.patch(
			`${apiUtils.getApiURL()}/quantities`,
			{
				quantityID: this.props.quantityID,
				isActive: 0
			}
		)
		.then(
			() => {
				// refresh the list
				QuantitiesActions.reload()

				this.setState({ showModal: false })
			}
		)
	}

	render() {
		return (
			<DeleteWithConfirm
				message="Are you sure you want to delete this quantity?"
				handleConfirm={this.handleConfirm}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/delete.jsx